/* eslint no-underscore-dangle: 0 */
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import Template from '../../../utils/api/templates';
import { setErrorNotification, setHeaderTitle } from '../../../redux/slices/NotificationSlice';
import {
  getAllTemplates,
  resetSignedUrl,
} from '../../../redux/slices/TemplateSlice';
import TemplateCategory from './TemplateCategory';

import SavedTemplates from './SavedTemplates';
// import CustomBannerTemplate from './CustomBannerTemplate';
import {
  BarDisplayIcon, BirthdayIcon, MenuBoardIcon, ShelfDisplayIcon,
} from '../../../shared/component/svgIcon';
import SearchBox from '../../../shared/component/form/SearchBox';
import { getI18Next } from '../../../utils/helpers';

function ViewTemplate() {
  const { t } = useTranslation();
  const currentLanguageCode = getI18Next();
  const dispatch = useDispatch();
  const [listIndex, setListIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [filter, setFilter] = useState('All');
  const [category, setCategory] = useState([]);
  const [templateLoader, setTemplateLoader] = useState(true);
  const [filterValue, setFilterValue] = useState('category-list-chosen');
  const [search, setSearch] = useState('');

  const {
    allTemplates,
    tabView,
  } = useSelector((state) => state?.currentTemplate);
  const [color, setColor] = useState(tabView);
  const getTemplate = () => {
    Template?.getTemplates()
      .then((res) => {
        const payload = res?.data?.results;
        setCategory(payload);
        setTemplateLoader(false);
        dispatch(getAllTemplates(payload));
      })
      .catch((error) => {
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  const handleTabClick = (tab) => {
    setColor(tab);
    if (tab === 'tab-1') {
      setCategory(allTemplates);
    }
  };
  useEffect(() => {
    if (allTemplates?.length === 0) {
      getTemplate();
    } else {
      setTemplateLoader(false);
      setCategory(allTemplates);
    }
    dispatch(resetSignedUrl());
  }, [color]);

  const handleCategoryClick = (list, index) => {
    setListIndex(index);
    setFilterValue('category-list');
    setFilter(list?._id);
  };
  const handleCategoryHover = (index) => {
    setHoverIndex(index);
  };
  const handleFocus = (index) => {
    setHoverIndex(index);
  };
  const handleCategoryLeave = (listed) => {
    setHoverIndex(listed);
  };

  const handleAllClick = () => {
    setFilter('All');
    setListIndex(null);
    setHoverIndex(null);
    setFilterValue('category-list-chosen');
  };
  const Icons = {
    'Menu Board': <MenuBoardIcon />,
    'Bar Display': <BarDisplayIcon />,
    'Shelf Display': <ShelfDisplayIcon />,
    Birthday: <BirthdayIcon />,
  };

  // debounce delay in ms (1.5 seconds)
  const onSearchHandle = debounce((changeValue) => {
    if (changeValue?.length > 0) {
      const object = {
        search: changeValue,
      };
      Template?.getTemplates(object)
        .then((res) => {
          const payload = res?.data?.results;
          setCategory(payload);
          setTemplateLoader(false);
          dispatch(getAllTemplates(payload));
        })
        .catch((err) => {
          setErrorNotification(err?.response?.data);
        });
    } else {
      getTemplate();
    }
  }, 1500);
  const handleSearchChange = useCallback((name, value) => {
    if (name === 'name') {
      setSearch(value); // Update local search state immediately
      onSearchHandle(value);
    }
  }, []);

  useEffect(() => {
    dispatch(setHeaderTitle(t('templates')));
  }, []);

  return (
    <div className={`template-view ${currentLanguageCode === 'ar' && 'rlt'}`}>
      <div className="template-wrapper">
        <div style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <div
            className={currentLanguageCode === 'ar' ? 'template_tabs-container-arabic' : 'template_tabs-container'}
          >
            <div className="template-tabs">
              <p
                className={color === 'tab-1' ? 'tabs-content-chosen' : 'tabs-content'}
                role="none"
                onClick={() => handleTabClick('tab-1', 1)}
              >
                {t('templates')}
              </p>
              <div className={color === 'tab-1' ? 'template-underline-bar-chosen' : 'template-underline-bar'}> </div>
            </div>
            <div className="template-tabs">
              <p
                className={color === 'tab-2' ? 'tabs-content-chosen' : 'tabs-content'}
                role="none"
                onClick={() => handleTabClick('tab-2', 2)}
              >
                {t('saved')}
              </p>
              <div className={color === 'tab-2' ? 'template-underline-bar-chosen' : 'template-underline-bar'}> </div>
            </div>
          </div>
          {color === 'tab-1'
            && (
              <div className="template-scroll">
                {/* <CustomBannerTemplate /> */}
                <div className="category-container">
                  <div className="category-wrap">
                    <div className={filterValue} onClick={() => handleAllClick()} role="none">
                      <p className="category-content">{t('all')}</p>
                    </div>
                    {category?.map((list, Index) => (
                      <div
                        className={(listIndex === Index || hoverIndex === Index)
                          ? 'category-list-chosen'
                          : 'category-list'}
                        key={list?.id}
                        role="none"
                        onClick={() => handleCategoryClick(list, Index)}
                        onMouseOver={() => handleCategoryHover(Index)}
                        onMouseLeave={() => handleCategoryLeave(listIndex)}
                        onFocus={() => handleFocus(Index)}
                      >
                        <div>{Icons?.[`${list?._id}`]}</div>
                        <p className="category-content">{t(`${list?._id}`)}</p>
                      </div>
                    ))}
                  </div>
                  <div className="search-box">
                    <SearchBox
                      type="text"
                      name="name"
                      value={search}
                      placeholder={t('searchByTemplateName')}
                      change={handleSearchChange}
                    />
                  </div>
                </div>
                <div className="template-container">
                  <TemplateCategory listed={filter} data={category} color={templateLoader} />
                </div>
              </div>
            )}
        </div>
        {color === 'tab-2'
          && (
            <SavedTemplates />
          )}
      </div>
    </div>

  );
}

export default ViewTemplate;
